import styled from '@emotion/styled';
import { Card, CardContent, Button, FormControlLabel } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { Text } from 'components/Texts';

export const SSOCard = styled(Card)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxShadow: theme.shadows[3],
  color: theme.colors.grey.dark,
  padding: '8% 5%',
  [theme.breakpoints.down('xs')]: {
    padding: '5% 1%',
  },
}));

export const SSOCardContent = styled(CardContent)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  [theme.breakpoints.down('xs')]: {
    textAlign: 'center',
  },
}));

export const SSOButton = styled(Button)<{
  theme: ICustomTheme;
  isMobile?: boolean;
}>(({ theme, isMobile }) => ({
  background: '#3f6595',
  fontSize: isMobile ? theme.fontSizes.mobileCTA : theme.fontSizes.desktopCTA,
  margin: 'auto',
  padding: theme.spacing(2, 3),
  textTransform: 'none',
}));

export const SeparatorContainer = styled.div<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  padding: theme.spacing(2, 0),
  width: '100%',
}));

export const SeparatorSlide = styled.div<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  background: theme.colors.grey.light4,
  flexGrow: 1,
  height: 1,
}));

export const SeparatorContent = styled(Text)<{
  theme: ICustomTheme;
  isMobile?: boolean;
}>(({ theme, isMobile }) => ({
  fontSize: isMobile
    ? theme.fontSizes.mobileBasicText
    : theme.fontSizes.desktopBasicText,
  color: theme.colors.grey.light2,
  margin: theme.spacing(0, 4),
}));

export const BottomPartWrapper = styled.div<{
  theme: ICustomTheme;
  isShrunken: boolean;
}>(({ isShrunken, theme }) => ({
  padding: theme.spacing(0, isShrunken ? 2 : 0),
}));

export const InputsContainer = styled.div<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  marginTop: theme.spacing(3.5),
  width: '100%',
}));

export const InputContainer = styled.div<{
  theme: ICustomTheme;
  isShrunken: boolean;
}>(({ isShrunken, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(isShrunken ? 1 : 3),
  '& :first-of-type': {
    paddingBottom: theme.spacing(0.5),
  },
}));

export const CheckboxAndPasswordForgot = styled.div<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: theme.spacing(2, 0),
}));

export const StyledFormControlLabel = styled(FormControlLabel)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  '& *': {
    margin: 0,
  },
}));

export const Subscribe = styled.div<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(3),
  '& :first-of-type': {
    marginRight: theme.spacing(3),
  },
}));

export const ButtonContainer = styled.div<{
  isShrunken: boolean;
  theme: ICustomTheme;
}>(({ isShrunken, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(isShrunken ? 0 : 3),
  marginTop: theme.spacing(isShrunken ? 0.5 : 6),
}));
